import React from "react";
import Iframe from "./Iframe";

function Preview({ url, isLoaded, handleLodingState }) {
  return (
    <div className="col p-0 d-flex justify-content-end " data-aos="fade-left">
      {!isLoaded ? (
        <>
          <div
            className={`position-absolute w-100 back-pre-div  h-100 bg-white d-flex align-items-center justify-content-center`}
            style={{ transition: ".3s" }}
          >
            <div className="load-effect">
              <h1 className=" text-center ">Loading...</h1>
              <p>it May takes a few minutes to render</p>
            </div>
          </div>
          <Iframe
            disable={true}
            url={url}
            handleLodingState={handleLodingState}
            isLoaded={isLoaded}
          />
        </>
      ) : (
        <Iframe
          disable={false}
          url={url}
          handleLodingState={handleLodingState}
          isLoaded={isLoaded}
        />
      )}
    </div>
  );
}

export default Preview;
